import React, { useState, useEffect } from 'react';
import { HVABXPCampaignsTable } from 'components/tables/HVABXPCampaignsTable';
import {
  fetchHVABXPCampaigns,
  HVACampaignWithBXP
} from 'services/hvaservicecampaign.service';

const HVABXPCampaignList: React.FC = () => {
  const [campaigns, setCampaigns] = useState<HVACampaignWithBXP[]>([]);

  const loadCampaigns = async (): Promise<void> => {
    try {
      const fetchedCampaigns = await fetchHVABXPCampaigns();
      setCampaigns(fetchedCampaigns);
    } catch (error) {
      console.error('Error loading campaigns:', error);
    }
  };

  useEffect(() => {
    loadCampaigns();
  }, []);

  return (
    <div>
      <div className="mb-2">
        <HVABXPCampaignsTable
          campaigns={campaigns}
          onCampaignsChange={loadCampaigns}
        />
      </div>
    </div>
  );
};

export default HVABXPCampaignList;
